import AppTitle from '@theme/components/atom/AppTitle'

export default {
  components: {
    AppTitle,
  },
}
